import { getUserDetailsCookie } from "../../utils/auth";

export function useProfileLogic() {
  const profile = getUserDetailsCookie();
  return {
    profile,
  };
}
